var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoteSend(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.511429 21L24.5 10.5L0.511429 0L0.5 8.16667L17.6429 10.5L0.5 12.8333L0.511429 21Z",
    fill: "#0091EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoteSend);
export default __webpack_public_path__ + "note-send.48d453c5ead2069527b11fb6154aa9dd.svg";
export { ForwardRef as ReactComponent };